export const environment = {
  apiUrl: 'https://endkundenrechner-api.qa.cpit.app',
  enableTestDataViewer: true,
  allowBrandingQueryParam: false,
};
